import StaticBuilder, {
  StaticBuilderSection,
  NavSideBarList,
  StaticBuilderDocumentPreview,
  NavSideBarMenuButton,
  StaticBuilderNavSideBarWrapper,
  StaticBuilderDocumentPreviewTitle,
} from 'StaticBuilder';
import StaticBuilderProgressBarWrapper from 'StaticBuilder/StaticBuilderProgressBarWrapper';
import StaticEmailButton from 'StaticBuilder/SessionEmail/StaticEmailButton';
import StaticEmailModal from 'StaticBuilder/SessionEmail/StaticEmailModal';
import ExportProgressBar from 'ExportProgressBar';
import { BuilderReactivationBanner } from 'ReactivationBanner';
import { ExportProgressBarModal, ReactivationOfferModal } from 'Modals';
import ExportDocumentPreviewAnimation from 'ExportDocumentPreviewAnimation';
import MessageHandler from 'message-handler';
import CreateAccountModal from 'Modals/CreateAccount';
import FinishLaterModal from 'Modals/FinishLater';
import StaticBuilderCreateAccountModal from 'Modals/StaticBuilderCreateAccount';
import SecondActionModal from 'StaticBuilderModals/SecondActionModal';
import DownloadOverlayContainer from '../../src-react/download-overlay/';
import DownloadOverlayManager from './download-overlay-manager';
import ReactCompatibility from './react-compatibility';
import StaticRequestSignatureContentSection from '../../src-react/StaticRequestSignatureContentSection';
import StaticCreateAccountSection from '../../src-react/StaticCreateAccountSection';

require('ui-tools');
require('polyfill');
window.SessionManager = require('session-manager');
window.OfferManager = require('offer-manager');
window.Form1099MiscEFile2014 = require('form-1099-misc-efile-2014');
window.Form1099MiscEFile2015 = require('form-1099-misc-efile-2015');
window.Form1099MiscEFile2016 = require('form-1099-misc-efile-2016');
window.Form1099MiscEFile2017 = require('form-1099-misc-efile-2017');
window.Form1099MiscEFile2018 = require('form-1099-misc-efile-2018');
window.Form1099MiscEFile2019 = require('form-1099-misc-efile-2019');
window.Form1099MiscEFile2020 = require('form-1099-misc-efile-2020');
window.Form1099MiscEFile2021 = require('form-1099-misc-efile-2021');
window.Form1099MiscEFile2022 = require('form-1099-misc-efile-2022');
window.Form1099NECEFile2020 = require('form-1099-nec-efile-2020');
window.Form1099NECEFile2021 = require('form-1099-nec-efile-2021');
window.Form1099NECEFile2022 = require('form-1099-nec-efile-2022');
window.FormW92014 = require('form-w9-2014');
window.FormW2EFile2014 = require('form-w2-efile-2014');
window.FormW2EFile2015 = require('form-w2-efile-2015');
window.FormW2EFile2016 = require('form-w2-efile-2016');
window.FormW2EFile2017 = require('form-w2-efile-2017');
window.FormW2EFile2018 = require('form-w2-efile-2018');
window.FormW2EFile2019 = require('form-w2-efile-2019');
window.FormW2EFile2020 = require('form-w2-efile-2020');
window.FormW2EFile2021 = require('form-w2-efile-2021');
window.FormW2EFile2022 = require('form-w2-efile-2022');
window.FormEmployeePaystub = require('form-employee-paystub');
window.FillStaticPdf = require('fill-static-pdf');
window.ProgressCircle = require('progress-circle');


window.StaticBuilderNavSideBarWrapper = StaticBuilderNavSideBarWrapper;
window.BuilderReactivationBanner = BuilderReactivationBanner;
window.DownloadOverlayManager = DownloadOverlayManager;
window.DownloadOverlayContainer = DownloadOverlayContainer;
window.NavSideBarList = NavSideBarList;
window.NavSideBarMenuButton = NavSideBarMenuButton;
window.ReactCompatibility = ReactCompatibility;
window.ReactivationOfferModal = ReactivationOfferModal;
window.StaticBuilder = StaticBuilder;
window.StaticRequestSignatureContentSection = StaticRequestSignatureContentSection;
window.StaticCreateAccountSection = StaticCreateAccountSection;
window.StaticBuilderDocumentPreview = StaticBuilderDocumentPreview;
window.StaticBuilderDocumentPreviewTitle = StaticBuilderDocumentPreviewTitle;
window.StaticBuilderSection = StaticBuilderSection;
window.ExportProgressBar = ExportProgressBar;
window.ExportDocumentPreviewAnimation = ExportDocumentPreviewAnimation;
window.ExportProgressBarModal = ExportProgressBarModal;
window.CreateAccountModal = CreateAccountModal;
window.FinishLaterModal = FinishLaterModal;
window.SecondActionModal = SecondActionModal;
window.MessageHandler = MessageHandler;
window.StaticBuilderProgressBarWrapper = StaticBuilderProgressBarWrapper;
window.StaticBuilderCreateAccountModal = StaticBuilderCreateAccountModal;
window.StaticEmailButton = StaticEmailButton;
window.StaticEmailModal = StaticEmailModal;
// duplicating logic in onboardingTour.js to show the react second action modal on first export
const showModalOnFirstExport = () => {
  const docCount = Number(window.COOKIE.get('num_of_docs'));
  const firstDocumentExported = window.COOKIE.get('firstDocumentExported');
  if (!firstDocumentExported && docCount === 1) {
    window.COOKIE.set('firstDocumentExported', 1);
    ReactCompatibility.openStaticSecondActionModal();
  }
};

// wrapper to test exportStaticWithURL
window.redirect = (path) => {
  if (path) {
    window.location = path;
  }
};

window.exportStaticWithURL = (trackCategory, trackAction, url, autoPrint) => {
  window._track(trackCategory, trackAction);
  window.SessionManager.save();

  // Put this url in global scope so we can pull out the url to go to if the export request
  // succeeds. Not sure why this doesn't work as a closure
  window.exportURL = url;

  const offerManager = new window.OfferManager();
  const exportCallback = () => {
    offerManager.requestExport(() => {
      if (typeof (FreemiumBox) !== 'undefined') {
        window.FreemiumBox.deductCredit();
      }

      // Only show the Download Overlay for downloads
      // and if we're not in autoPrint mode
      if (!autoPrint) {
        window.DownloadOverlayManager.show();
      }

      window.redirect(window.exportURL);
    }, `/new-account-for-doc?${window.location.search.substr(1)}`, true);
    showModalOnFirstExport();
    window.onbeforeunload = () => null;
  };
  window.ProgressCircle.init(exportCallback);
  return false;
};

window.exportStatic = (e, trackCategory, trackAction, button, autoPrint) => {
  e.preventDefault();
  return window.exportStaticWithURL(trackCategory, trackAction, $(button).attr('href'), autoPrint);
};

window.fixStaticBuilderNavPlacement = () => {
  // Adjust for the precense of the message bar on the static and visual static builders
  if ($('.message-bar').length) {
    $('#exportButtons').css('top', `+=${$('.message-bar').outerHeight()}`);
  }
};

window.activateBootstrapTooltips = () => {
  $('button[rel=tooltip]').tooltip({ placement: 'right' });
};



// WEBPACK FOOTER //
// ./src-assets/js/builder.js